export enum Gamestate {
  WelcomeScreen = 0,
  AddPlayers = 1,
  Playing = 2
}